// Used to post documents both on the study and reviewer views
import getUrl from 'api/apiMap'
import useMutateApi from '../useMutateApi'

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

const usePostReviewerDocument = (taskId) => {
  return useMutateApi({
    method: 'post',
    apiEndpoint: getUrl(`${apiEndpoints.reviewerDocuments}?task-id=${taskId}`),
    invalidateQueries: [queryKeys.documents.all],
    successMsg: "Successfully created file"
  })
}

export {
  usePostReviewerDocument,
}